let enemyConfig = {
  type: "enemy",
  count: 3,
  x: 200,
};

module.exports = enemyConfig;
